import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Contact', path: '/enquiry' },
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img 
              src="https://static.readdy.ai/image/4c54787fd2047152d108467e5113439e/e0bc0de17f7db1376f77c164960b5684.jpeg" 
              alt="GrowthLink Marketing Solutions Logo" 
              className="h-12 w-12 object-contain"
            />
            <span className={`text-2xl font-bold font-serif transition-colors ${
              scrolled ? 'text-dark' : 'text-white'
            }`}>
              GrowthLink Marketing Solutions
            </span>
          </Link>

          <div className="flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-base font-medium transition-all hover:scale-105 whitespace-nowrap ${
                  location.pathname === link.path
                    ? scrolled ? 'text-primary' : 'text-secondary'
                    : scrolled ? 'text-gray-700 hover:text-primary' : 'text-white/90 hover:text-white'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/enquiry"
              className={`px-6 py-3 rounded-full font-medium transition-all hover:scale-105 whitespace-nowrap ${
                scrolled 
                  ? 'bg-dark text-white hover:bg-primary' 
                  : 'bg-white text-dark hover:bg-secondary hover:text-white'
              }`}
            >
              Get Started
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
